export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  searchText: string;
  sortField: string;
  sortOrder: string;
  status: number;
};

export type MasterTableDataType = {
  insuranceCode: string;
  insuranceId: number;
  insuranceName: string;
  insuranceStatus: number;
  insuranceTypeName: string;
  insurancePayerId: string;
  insuranceClinicId: number;
  insuranceReceiverId: string;
  license: string;
  insuranceTypeId: number;
};

export type SaveResponseType = {};

export type LabListType = {
  name: string;
  id: number;
};

export type MasterFormDataType = {
  insuranceCode: string;
  insuranceName: string;
  insuranceStatus: number;
  license: string;
  insuranceType: LabListType | null;
};

export type MasterDataType = {
  clinicId: number;
  insuranceName: string;
  insuranceCode: string;
  license: string;
  insuranceTypeId: number;
  insuranceStatus: number;
  insuranceCreatedByDate: string;
  insuranceCreatedById: number;
  insuranceId: number;
};

export const initialFormData: MasterFormDataType = {
  insuranceCode: "",
  insuranceName: "",
  insuranceStatus: 1,
  license: "",
  insuranceType: null,
};
